import { SeatMapRowSeat } from '../model/types';

export function getIsSeatAvailableByCombineWith(activeDoubleSeats: boolean) {
	return (seat: SeatMapRowSeat): SeatMapRowSeat => {
		if (!activeDoubleSeats) {
			return seat;
		}

		return {
			...seat,
			isAvailable: seat.isAvailable && !!Object.keys(seat.combinedWith).length
		};
	};
}
